import { createCalendarEvent } from 'owa-timestream-asset-sdk-calendarevents';
import { setGoalDateProperties } from './setGoalDateProperties';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default function createGoalEvent(
    title: string,
    date: string,
    tz: string,
    projectName: string,
    projectUrl: string
) {
    logSpacesDatapoint('OUTLOOKSPACES_GOAL_CREATE_EVENT');
    const a = document.createElement('a');
    a.href = a.title = projectUrl;
    a.innerText = projectName;

    return createCalendarEvent(
        'SpacesGoalAsset',
        setGoalDateProperties(
            {
                CharmId: 58 /* goal */,
                Subject: title,
                FreeBusyType: 'Free',
                Body: {
                    BodyType: 'HTML',
                    Value: `<div>${a.outerHTML}</div>`,
                },
                Locations: [
                    {
                        Id: projectUrl,
                        DisplayName: projectUrl,
                        PostalAddress: {
                            LocationSource: 'None',
                            Type: 'Other',
                        },
                    },
                ],
            },
            date,
            tz
        )
    ).catch(onCreateGoalEventFailed);
}

function onCreateGoalEventFailed() {
    logSpacesDatapoint('OUTLOOKSPACES_GOAL_CREATE_EVENT_FAILED');
    return null;
}
